import { observer } from "mobx-react";
import * as React from "react";
import { Redirect, Route } from "react-router-dom";
import { authStore } from "../../../stores/AuthStore";
import { HrRoutes } from "../../hr/router/HrRoutes";

export const NoAuthOnlyRoute: any = observer(({ component: Component, ...props }: any): any => {
    const isAuthenticated = authStore.isAuthenticated;

    return (
        <Route
            {...props}
            render={(props: any): any =>
                !isAuthenticated ? (
                    <Component {...props} />
                ) : (
                    <>
                        {
                            <Redirect
                                to={{
                                    pathname: authStore.redirectAfterLogin ?? HrRoutes.DASHBOARD
                                }}
                            />
                        }
                    </>
                )
            }
        />
    );
});
